<template>
  <div>
    <div class="dropdown">
        <button id="drop-lang-btn" @click="clickDropdown()">
            <div>
                {{localeCode === 1033 ? lbl.language.dropdown.en : lbl.language.dropdown.th }}
            </div>
            <img class="my-auto" src="@/assets/icon/ic-arrow-down.svg" />
        </button>
        <div v-if="showList" class="dropdown-content">
            <div class="item" @click="clickSwitchLang(1054)">
                <template v-if="localeCode === 1054">
                    <div class="active">
                        {{ lbl.language.dropdown.th }}
                    </div>
                    <img src="../../../../assets/new/icon/ic-lang-select.png" />
                </template>
                <template v-else>
                    <span>
                        {{ lbl.language.dropdown.th }}
                    </span>
                </template>
            </div>
            <div class="item" @click="clickSwitchLang(1033)">
                <template v-if="localeCode === 1033">
                    <div class="active">
                        {{ lbl.language.dropdown.en }}
                    </div>
                    <img src="../../../../assets/new/icon/ic-lang-select.png" />
                </template>
                <template v-else>
                    <span>
                        {{ lbl.language.dropdown.en }}
                    </span>
                </template>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'ButtonDropdown',
    mixins:[ModalMixin,LocaleMixin],
    data: function() {
        return {
            showList: false,
        }
    },
    created: function() {
    },
    computed: {
    },
    methods: {
        clickDropdown: function() {
            this.showList = !this.showList
        },
        clickSwitchLang: function(localeCode) {
            this.switchLang(localeCode)
        },
    },
}
</script>

<style scoped lang="scss">
@import "../../../../style/base/base.scss";
@import "./ButtonDropdown.scss";
</style>
